import { connect } from 'react-redux';
import SearchResults from './search_results';
import { fetchSuggestions, dismissSuggestion } from 'brighteon/actions/suggestions';
import { expandSearch } from 'brighteon/actions/search';

const mapStateToProps = state => ({
  results: state.getIn(['search', 'results']),
  suggestions: state.getIn(['suggestions', 'items']),
  searchTerm: state.getIn(['search', 'searchTerm']),
  me: state.getIn(['meta', 'me']),
});

const mapDispatchToProps = dispatch => ({
  fetchSuggestions: () => dispatch(fetchSuggestions()),
  expandSearch: type => dispatch(expandSearch(type)),
  dismissSuggestion: account => dispatch(dismissSuggestion(account.get('id'))),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchResults);
